module.exports = __webpack_public_path__ + "img/icon-bg-expired.fd0a0bbc.png";